import axios from "axios";
import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage } from "firebase/messaging";

const firebaseConfig = {
    apiKey: "AIzaSyDbiKr3XVoVmX3w_mj9ZYvqlDGPlBikwh4",
    authDomain: "followvita.firebaseapp.com",
    projectId: "followvita",
    storageBucket: "followvita.firebasestorage.app",
    messagingSenderId: "673919923458",
    appId: "1:673919923458:web:14c9c9d9748e9556247e1b"
};


// Initialize Firebase
const app = initializeApp(firebaseConfig);
const messaging = getMessaging(app);

// Register service worker
async function registerServiceWorker() {
    try {
        if (!('serviceWorker' in navigator)) {
            throw new Error('Service worker not supported in this browser');
        }

        const registration = await navigator.serviceWorker.register('/firebase-messaging-sw.js', {
            scope: '/'
        });

        await navigator.serviceWorker.ready;
        return registration;
    } catch (error) {
        console.error('Service Worker registration failed:', error);
        throw error;
    }
}

// Request permission and handle FCM token
export const requestPermission = async (accessToken) => {
    try {
        const API_URL = import.meta.env.VITE_API_URL;
        const swRegistration = await registerServiceWorker();
        const permission = await Notification.requestPermission();

        if (permission !== 'granted') {
            console.warn('Notification permission denied');
            throw new Error('Notification permission denied');
        }
        let currentToken;
        try {
            currentToken = await getToken(messaging, {
                vapidKey: import.meta.env.VITE_FIREBASE_VAPID_KEY,
                serviceWorkerRegistration: swRegistration
            });
        } catch (tokenError) {
            console.error('Error generating token:', tokenError);
            throw new Error(`Failed to generate FCM token: ${tokenError.message}`);
        }

        if (!currentToken) {
            console.error('No FCM token generated - token is null or undefined');
            throw new Error('Failed to generate FCM token - token is null');
        }
        const response = await axios.patch(`${API_URL}/userDevices`,
            { fcmToken: currentToken },
            { headers: { Authorization: `Bearer ${accessToken}` } }
        );

        // Check if FCM token was successfully registered
        if (response.status === 200) {
            return { success: true, token: currentToken };
        } else {
            console.warn('FCM token registration failed with status:', response.status);
            return { success: false, token: currentToken };
        }

    } catch (error) {
        console.error('Error in FCM setup:', error);
        return { success: false, error: error.message };
    }
};

// Listen for foreground messages
export const onMessageListener = () =>
    new Promise((resolve) => {
        onMessage(messaging, (payload) => {
            console.log("Received foreground message:", payload);
            resolve(payload);
        });
    });